import { render, staticRenderFns } from "./DraggableSortList.vue?vue&type=template&id=24bc405c&scoped=true&"
import script from "./DraggableSortList.vue?vue&type=script&lang=js&"
export * from "./DraggableSortList.vue?vue&type=script&lang=js&"
import style0 from "./DraggableSortList.vue?vue&type=style&index=0&id=24bc405c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc405c",
  null
  
)

export default component.exports